export default __webpack_public_path__ + "static/media/mg-img.b4ef5941.webp";